/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import useAPIHandler from "../../../hook/use-api-handler";
import useSnackbar from "../../../hook/use-snakbar";
import { getDateProperFormatForInput, getErrorDetailsFn, getInputFieldProps, safeToString } from "../../../utils/common";
import useOrgDetailsService from "../../organization-details/use-orgdetails-service";
import { ESI_API, ESI_INITIAL_STATE, ESI_INPUT_FIELDS } from "./esi-constant";
import { esiFormSchema } from "./esi-validation";




const useEsiService = () => {
  const { allState} = useOrgDetailsService()
  const [openStatutoryEPFModal, setOpenStatutoryEPFModal] = useState(false);
  const [openEPFAddressModal, setOpenEPFAddressModal] = useState(false);

  const handleOpenStatutoryEPFModal = () => setOpenStatutoryEPFModal(true);
  const handleCloseStatutoryEPFModal = () => setOpenStatutoryEPFModal(false);

  const handleOpenEPFAddressModal = () => setOpenEPFAddressModal(true);
  const handleCloseEPFAddressModal = () => setOpenEPFAddressModal(false);

  const [viewESIDetails, setViewESIDetails] = useState({})
  const [esiInputs, setesiInputs] = useState(structuredClone(ESI_INITIAL_STATE));
  const {
    snackbarVisible,
    snackbarMessage,
    openSnackbar,
    closeSnackbar,
    snackColor,
  } = useSnackbar();

  const { fetchData } = useAPIHandler();
  const [createUpdateLoading, setCreateUpdateLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const handleChangeFunction = (e, name) => {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    if (
      ESI_INPUT_FIELDS[name].customOptions &&
      ESI_INPUT_FIELDS[name].customOptions?.formatValueFn
    ) {
      value = ESI_INPUT_FIELDS[name].customOptions?.formatValueFn(
        value,
        esiInputs
      );
    }

    setesiInputs((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));

    const fieldSchema = esiFormSchema.extract(name);
    const { error } = fieldSchema.validate(value, {
    });

 
    if (!error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: undefined,
      }));
    }
  };

  

  function handleBlurFn(e, name) {
    let value = e;

    if (e && e.target) {
      value = e.target.value;
    }

    const fieldSchema = esiFormSchema.extract(name);
    const { error } = fieldSchema.validate(value);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error ? error.details[0].message : undefined,
    }));
  }


  const handleSubmitFn = async () => {
    const URL = ESI_API.ESI_CREATE.URL;
    const METHOD = ESI_API.ESI_CREATE.METHOD;



    const {
      employer_contribution,
      employee_contribution,
      country,

      isDisableEsi,
      is_esi,
      esi_code,
      coverage_date,
      esi_office,
      address,
      city,
      state = '',
      pincode,
      location,
      is_including_employee_ctc,
    } = esiInputs;
    const payload = {
      data: {
        employer_contribution,
        employee_contribution,
        country: "1",
        // isDisableEsi,

        esi_code,
        coverage_date,
        esi_office,
        address,
        city,
        state: state ?? "",
        pincode,
        location,
        is_including_employee_ctc,
        is_esi
      },
      url: URL,
      method: METHOD,
    };

    let error = {};


 

      const objValida = esiFormSchema.validate(
        {
          employer_contribution,
          employee_contribution,
          country,
          is_esi,
          esi_code,
          coverage_date,
          esi_office,
          address,
          city,
          state,
          pincode,
          location,
          is_including_employee_ctc,
        },
        {
          abortEarly: false,
        }
      );
      if(is_esi){
        error = objValida?.error;
     
      }
   



    if (error && error?.details?.length > 0) {
      const validationErrors = error.details.reduce((acc, err) => {
        const pathname = err.path.join(".");
        acc[pathname] = err.message;
        return acc;
      }, {});
      setErrors(validationErrors);
    } else {
      setCreateUpdateLoading(true);

      try {
        await fetchData(payload);



        setViewESIDetails(payload?.data)
        setOpenStatutoryEPFModal(false);
        setOpenEPFAddressModal(false)

        openSnackbar({
          message: "ESI Updated succesfully!",
          color: "success",
        });






      } catch (error) {

        const {


          message,
          errorObj
        } = getErrorDetailsFn(error);

        openSnackbar({
          message,
          color: "danger",
        });
        setErrors(errorObj);
        setCreateUpdateLoading(false);
      } finally {
        setCreateUpdateLoading(false);
      }
    }
  };

  function handleDisableAllESIFn() {
    if (esiInputs?.is_esi) {
      setErrors({});
      setesiInputs({ ...structuredClone(ESI_INITIAL_STATE), isDisableEsi: false,is_esi:false });
    } else {
      setesiInputs((prev) => ({ ...prev, isDisableEsi: true,is_esi:true }));
    }
  }

  const [stateList, setStateList] = useState([]);
  const getInputFieldPropsFn = (fieldName = "") => {
    const { customOptions = {}, ...restProps } =
      ESI_INPUT_FIELDS[fieldName] || {};


    const error = safeToString(errors[fieldName]);
    const props = {
      ...restProps,
      ...getInputFieldProps({
        name: fieldName,
        stateValues: esiInputs,
        type: restProps.type || "text",
        error,
        handleChangeFunction,
        handleBlurFn
      }),
    };


    return props;
  };


  useEffect(() => {

    setErrors({});
    const URL = ESI_API.ESI_LIST.URL;
    const METHOD = ESI_API.ESI_LIST.METHOD;
    const payload = {
      url: URL,
      METHOD
    }
    fetchData(payload).then(
      (res) => {

        const resData = res?.data || {};

        resData.coverage_date = getDateProperFormatForInput(resData?.coverage_date);



        setesiInputs({
          ...structuredClone(ESI_INITIAL_STATE), ...resData, country: 1,

          employer_contribution: 3.25,
          employee_contribution: 0.75,

        });
        setViewESIDetails({ ...resData })
      }

    );


    fetchData({ url: "/common/state" }).then(
      (res) => {

        setStateList(res?.data?.map(
          it => ({
            ...it,

            id: it.state_id,
            name: it.state_name
          })
        ));
      }
    );
  }, [openStatutoryEPFModal]);
  function getStateName(id) {
    const stateName = allState.find(item => item.id === id);

    return stateName ? stateName?.name : 'N/A'
  }

  return {
    esiInputs,
    setesiInputs,
    getInputFieldProps: getInputFieldPropsFn,
    handleDisableAllESIFn,
    handleSubmitFn,
    createUpdateLoading,
    stateList,
    snackbarVisible,
    snackbarMessage,
    closeSnackbar,
    snackColor,
    viewESIDetails,
    openStatutoryEPFModal,
    handleOpenStatutoryEPFModal,
    handleCloseStatutoryEPFModal,
    openEPFAddressModal,
    handleOpenEPFAddressModal,
    handleCloseEPFAddressModal,
    getStateName
  };
};

export default useEsiService;